import React from "react";
import styles from "./Example.module.css";
export default function Example() {
    return (
        <div>
            <div>
                <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                    My Trip to Paris
                </span>
                <span
                    style={{
                        display: "inline-block",
                        color: "green",
                        height: "30px",
                    }}
                >
                    |{" "}
                </span>
                <span style={{ color: "red", fontSize: "30px" }}>
                    {" "}
                    powered by{" "}
                </span>
                <span style={{ color: "red", fontSize: "30px" }}> wawiwa </span>
            </div>
            <div>
                <img
                    src="/images/11062b_0137d9ef6e8b43a0998147a2cea02cb6~mv2.webp"
                    alt="back"
                    style={{ padding: "0px", margin: "0px", width: "100%" }}
                />
            </div>
            <div style={{ padding: "50px" }}>
                <table>
                    <tr>
                        <td>
                            <img
                                src="/images/11062b_19b63cb87aab47c89c70ab7eb9eec66d~mv2.webp"
                                alt="back"
                                style={{
                                    padding: "0px",
                                    margin: "0px",
                                    width: "400px",
                                    height: "225px",
                                }}
                            />
                        </td>
                        <td
                            style={{
                                textAlign: "left",
                                margin: "15px",
                                padding: "5px",
                            }}
                        >
                            <h1 style={{ color: "rgb(90, 133, 142)" }}>
                                MY TRIP TO PARIS
                            </h1>
                            <p>
                                Welcome to My Trip to Paris! Join me on a
                                journey through the City of Light as I explore
                                its history, culture, and attractions.{" "}
                            </p>
                            <p>
                                From the Eiffel Tower to the Louvre Museum,
                                we'll discover all the wonders this city has to
                                offer.
                                <p>
                                    Come along and let's make some unforgettable
                                    memories together!
                                </p>
                            </p>
                            <button
                                style={{
                                    background: "red",
                                    color: "white",
                                    padding: "5px",
                                    fontSize: "30px",
                                }}
                            >
                                Explore Paris with me
                            </button>
                        </td>
                        <td></td>
                    </tr>
                </table>
                <div>
                    <h1 style={{ color: "rgb(90, 133, 142)" }}>
                        My photo album
                    </h1>
                    <table>
                        <tr>
                            <td>
                                <img
                                    src="/images/11062b_2bd9f017f24d4c9a8bd0346f99c97b40~mv2.webp"
                                    alt="album"
                                    style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "80%",
                                    }}
                                />
                            </td>
                            <td>
                                <img
                                    src="/images/11062b_b02a00e3c06f48698b9168b108a264e8~mv2.webp"
                                    alt="back"
                                    style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "80%",
                                    }}
                                />
                            </td>
                            <td>
                                <img
                                    src="/images/11062b_b6494dd0f84f43c08bd066a3c3ad97b9~mv2.webp"
                                    alt="back"
                                    style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "80%",
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <img
                                    src="/images/11062b_ddab96fe96d64b2482298bf4c0d72917~mv2.webp"
                                    alt="album"
                                    style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "80%",
                                    }}
                                />
                            </td>
                            <td>
                                <img
                                    src="/images/11062b_f20f71234d4d41c9b24eb59315bf6b6e~mv2.webp"
                                    alt="back"
                                    style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "80%",
                                    }}
                                />
                            </td>
                            <td>
                                <img
                                    src="/images/ff69cee1bd3e40a58e8290fa828f38d4.webp"
                                    alt="back"
                                    style={{
                                        padding: "0px",
                                        margin: "0px",
                                        width: "80%",
                                    }}
                                />
                            </td>
                        </tr>
                    </table>
                </div>
                <table style={{}}>
                    <tr>
                        <td
                            style={{
                                color: "rgb(90, 133, 142)",
                                fontSize: "30px",
                            }}
                        >
                            Useful Links
                        </td>
                        <td style={{ textAlign: "left", padding: "10px" }}>
                            <p style={{ color: "red", fontSize: "30px" }}>
                                1 / Paris Tourist Information
                            </p>
                            <p>
                                <a href="https://www.ParisTouristInfo.com">
                                    ParisTouristInfo
                                </a>
                            </p>
                            <p style={{ color: "red", fontSize: "30px" }}>
                                2 / Paris Metro Map
                            </p>
                            <p>
                                <a href="https://metro.fr">metro</a>
                            </p>
                            <p style={{ color: "red", fontSize: "30px" }}>
                                3 / Paris Nightlife
                            </p>
                            <p>
                                <a href="https://www.parisatnight.com">
                                    parisatnight
                                </a>
                            </p>
                        </td>
                    </tr>
                </table>
            </div>
            <div
                style={{
                    backgroundColor: "rgb(229,229,231)",
                    width: "100%",
                    padding: "10px",
                }}
            >
                <h1 style={{ color: "rgb(90, 133, 142)" }}>My itinerary...</h1>
                <table
                    border="3"
                    style={{
                        textAlign: "left",
                        margin: "100px",
                        padding: "100px",
                        borderSpacing: "10px", // Add this line to set the spacing between cells
                    }}
                >
                    <thead
                        style={{
                            color: "red",
                            fontSize: "30px",
                            textAlign: "center",
                        }}
                    >
                        <tr>
                            <th>Date</th>
                            <th>Location</th>
                            <th>Directions</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody
                        style={{
                            color: "black",
                            fontSize: "20px",
                        }}
                    >
                        <tr>
                            <td style={{ padding: "10px" }}>
                                November 1st, Day 1
                            </td>
                            <td style={{ padding: "10px" }}>CDG Airport</td>
                            <td style={{ padding: "10px" }}>Fly by airplane</td>
                            <td style={{ padding: "10px" }}>
                                Important to check-in to your flight in advance.
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "10px" }}>
                                November 2nd, Day 2
                            </td>
                            <td style={{ padding: "10px" }}>Louvre Museum</td>
                            <td style={{ padding: "10px" }}>
                                Metro to Gare Nord
                            </td>
                            <td style={{ padding: "10px" }}>
                                Buy tickets online to save time and money
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "10px" }}>
                                November 3rd, Day 3
                            </td>
                            <td style={{ padding: "10px" }}>Tour Eiffel</td>
                            <td style={{ padding: "10px" }}>
                                Metro to Tour Eiffel Station
                            </td>
                            <td style={{ padding: "10px" }}>
                                It's best to come before sunset and enjoy the
                                view
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <h1>Contact me to ask any question!</h1>
                <input
                    style={{ width: "400px", padding: "15px" }}
                    type="text"
                    placeholder="Email Address"
                />
                <div>
                    <button
                        style={{
                            width: "200px",
                            padding: "10px",
                            background: "rgb(90,133,142)",
                            margin: "20px",
                            color: "white",
                            fontSize: "30px",
                        }}
                    >
                        Write me
                    </button>
                </div>
                <div>
                    <p>© 2024 by [Student Name] | Powered by Wawiwa Tech</p>
                </div>
            </div>
        </div>
    );
}
